import React from 'react'
import { t } from 'src/translations'
import Button from 'shared/components/common/button'
import { ChevronRightIcon } from '@toasttab/buffet-pui-icons'

type LoggedOutAccountStateProps = {
  onDeleteAccountClick: () => void
}

export const LoggedOutAccountState = ({
  onDeleteAccountClick
}: LoggedOutAccountStateProps) => {
  return (
    <div
      className='accountSections loggedOutAccountState'
      data-testid='LoggedOutAccountState'
    >
      <div
        className='accountSection accountSettings'
        data-testid='LoggedOutAccountSettings'
      >
        <div className='sectionHeader'>
          <h2 className='sectionTitle'>{t('account-settings.account')}</h2>
        </div>
        <div className='actions'>
          <Button
            className='deleteAccountButton'
            onClick={onDeleteAccountClick}
            data-testid='delete-account-cta'
          >
            {t('account-settings.delete-this-account')}
            <ChevronRightIcon accessibility='decorative' />
          </Button>
        </div>
      </div>
    </div>
  )
}
